import React from 'react';

export default ({ color, viewBox, ...props }) => (
    <svg
        viewBox={viewBox || '0 0 129 129'}
        fill="none"
        {...props}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g>
            <path
                fill={color || '#1D1D1D'}
                d="m118.5,76.7c-2.3,0-4.1,1.8-4.1,4.1v33.5h-99.8v-99.7h33.5c2.3,5.32907e-15 4.1-1.8 4.1-4.1s-1.8-4.1-4.1-4.1h-37.6c-2.3,0-4.1,1.8-4.1,4.1v107.9c0,2.3 1.8,4.1 4.1,4.1h107.9c2.3,0 4.1-1.8 4.1-4.1v-37.6c0.1-2.2-1.8-4.1-4-4.1z"
            />
            <path
                fill={color || '#1D1D1D'}
                d="m122.3,9c-0.5-1-1.3-1.8-2.3-2.3 0,0 0,0-0.1,0-0.5-0.2-1-0.3-1.5-0.3h-54c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1 4.1,4.1h44.1l-47,47c-1.6,1.6-1.6,4.2 0,5.8 0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l47-47v44.1c0,2.3 1.8,4.1 4.1,4.1 2.3,0 4.1-1.8 4.1-4.1v-54c0.1-0.5-0.1-1-0.2-1.5z"
            />
        </g>
    </svg>
);
